export default {
  getToken: (state) => state.token,
  getUsername: (state) => state.username,
  isLoggedIn: (state) => state.username?.length > 0,
  isInRole: (state) => (role) => state.roles.some((r) => r === role),
};
